/**
 * @desc 分页
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = defs.tms.ResponseDto<
  defs.tms.IPage<defs.tms.CustomsDeclarationContractResponseDto>
>;
export function request(
  params: API.tms.customsDeclarationContract.page.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/customsDeclarationContract/page`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
